import type { SVGProps } from 'react';

const IconBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  />
);

export const IconCross = (props: SVGProps<SVGSVGElement>) => (
  <IconBase viewBox="0 0 20 20" fill="currentColor" stroke="none" {...props}>
    <rect x="8" y="2" width="4" height="16" rx="1.4" />
    <rect x="2" y="8" width="16" height="4" rx="1.4" />
  </IconBase>
);

export const IconHome = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M3 9.5 10 3l7 6.5" />
    <path d="M5 8v9h4v-5h2v5h4V8" />
  </IconBase>
);

export const IconDashboard = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <rect x="2.7" y="2.7" width="6" height="6" rx="1.2" />
    <rect x="11.3" y="2.7" width="6" height="3.8" rx="1.2" />
    <rect x="2.7" y="11.3" width="6" height="6" rx="1.2" />
    <rect x="11.3" y="9.1" width="6" height="8.2" rx="1.2" />
  </IconBase>
);

export const IconUsers = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <circle cx="7.2" cy="7" r="2.9" />
    <path d="M1.8 17.2c0-3.4 2.4-5.7 5.4-5.7s5.4 2.3 5.4 5.7" />
    <circle cx="14.6" cy="7.6" r="2.1" />
    <path d="M12.9 11.7c2.5.2 4.3 2.2 4.6 5.1" />
  </IconBase>
);

export const IconShield = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M10 2.2 16 4.7v4.8c0 4-2.5 6.5-6 8.3-3.5-1.8-6-4.3-6-8.3V4.7L10 2.2Z" />
    <path d="m7.2 10 1.8 1.8 3.8-4" />
  </IconBase>
);

export const IconPencil = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="m13.8 3.2 3 3" />
    <path d="m4 16 .8-3.6L13.8 3.4a1.7 1.7 0 0 1 2.4 2.4l-9 8.9L4 16Z" />
  </IconBase>
);

export const IconCalendar = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <rect x="3" y="4.3" width="14" height="13.2" rx="2" />
    <line x1="3" y1="8.3" x2="17" y2="8.3" />
    <line x1="6.6" y1="2.4" x2="6.6" y2="6" />
    <line x1="13.4" y1="2.4" x2="13.4" y2="6" />
    <circle cx="7.2" cy="12.3" r="0.9" fill="currentColor" stroke="none" />
    <circle cx="10.2" cy="12.3" r="0.9" fill="currentColor" stroke="none" />
    <circle cx="13.2" cy="12.3" r="0.9" fill="currentColor" stroke="none" />
  </IconBase>
);

export const IconBed = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <line x1="2.2" y1="17" x2="2.2" y2="6.5" />
    <rect x="2.2" y="7.2" width="5.4" height="3.6" rx="1.1" />
    <path d="M2.2 12.2h14.1a1.7 1.7 0 0 1 1.7 1.7V17" />
    <line x1="17.8" y1="17" x2="17.8" y2="15.4" />
  </IconBase>
);

export const IconFlask = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M8 2.8h4" />
    <path d="M8.7 2.8v5.6L4.4 15a1.9 1.9 0 0 0 1.6 2.9h8a1.9 1.9 0 0 0 1.6-2.9l-4.3-6.6V2.8" />
    <line x1="6.3" y1="12.1" x2="13.7" y2="12.1" />
  </IconBase>
);

export const IconIdCard = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <rect x="2.3" y="4.2" width="15.4" height="11.6" rx="2" />
    <circle cx="7" cy="8.9" r="1.7" />
    <path d="M4.6 12.9c.5-1.5 1.4-2.2 2.4-2.2s1.9.7 2.4 2.2" />
    <line x1="11.6" y1="7.8" x2="14.8" y2="7.8" />
    <line x1="11.6" y1="10.2" x2="14.8" y2="10.2" />
    <line x1="11.6" y1="12.6" x2="13.6" y2="12.6" />
  </IconBase>
);

export const IconPill = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <g transform="rotate(-45 10 10)">
      <rect x="4" y="6.8" width="12" height="6.4" rx="3.2" />
      <line x1="10" y1="6.8" x2="10" y2="13.2" />
    </g>
  </IconBase>
);

export const IconWallet = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M3.3 6.4a2 2 0 0 1 2-2h8.4a1 1 0 0 1 1 1v1.4" />
    <rect x="2.6" y="6.4" width="14.8" height="10.6" rx="2" />
    <circle cx="13.2" cy="11.7" r="1.3" fill="currentColor" stroke="none" />
  </IconBase>
);

export const IconChart = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <line x1="2.6" y1="17.2" x2="17.4" y2="17.2" />
    <rect x="4" y="11.2" width="2.8" height="6" rx="0.7" />
    <rect x="8.5" y="7.2" width="2.8" height="10" rx="0.7" />
    <rect x="13" y="3.8" width="2.8" height="13.4" rx="0.7" />
  </IconBase>
);

export const IconSettings = (props: SVGProps<SVGSVGElement>) => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" />
  </IconBase>
);

export const IconSearch = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <circle cx="8.6" cy="8.6" r="5.4" />
    <line x1="16.5" y1="16.5" x2="12.7" y2="12.7" />
  </IconBase>
);

export const IconBell = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M10 2.9a4 4 0 0 0-4 4v2.3c0 1-.4 1.9-1.1 2.6L4 12.9h12l-.9-1.1a3.9 3.9 0 0 1-1.1-2.6V6.9a4 4 0 0 0-4-4z" />
    <path d="M8.3 15.9a1.8 1.8 0 0 0 3.4 0" />
  </IconBase>
);

export const IconLogout = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M8 17H4.8A1.8 1.8 0 0 1 3 15.2V4.8A1.8 1.8 0 0 1 4.8 3H8" />
    <line x1="17" y1="10" x2="8.3" y2="10" />
    <path d="M13.4 6.3 17 10l-3.6 3.6" />
  </IconBase>
);

export const IconMenu = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <line x1="3" y1="6" x2="17" y2="6" />
    <line x1="3" y1="10" x2="17" y2="10" />
    <line x1="3" y1="14" x2="17" y2="14" />
  </IconBase>
);

export const IconClose = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <line x1="5" y1="5" x2="15" y2="15" />
    <line x1="15" y1="5" x2="5" y2="15" />
  </IconBase>
);

export const IconCheck = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M4.5 10.5 8 14l7.5-8" />
  </IconBase>
);

export const IconLock = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <rect x="4.5" y="9" width="11" height="7.6" rx="2" />
    <path d="M6.8 9V6.6a3.2 3.2 0 0 1 6.4 0V9" />
    <circle cx="10" cy="12.6" r="1" fill="currentColor" stroke="none" />
  </IconBase>
);

export const IconChevron = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M6 7.5 10 12l4-4.5" />
  </IconBase>
);

export const IconPulse = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M2.3 10.2h3l1.6-4.4 3 8.4 1.9-4h5.9" />
  </IconBase>
);

export const IconClock = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <circle cx="10" cy="10.5" r="7" />
    <path d="M10 6.5v4l2.8 1.8" />
  </IconBase>
);

export const IconDroplet = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M10 2.6s5.4 6 5.4 9.7a5.4 5.4 0 1 1-10.8 0C4.6 8.6 10 2.6 10 2.6z" />
  </IconBase>
);

export const IconBaby = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <circle cx="10" cy="8.6" r="4.4" />
    <circle cx="8.2" cy="8" r="0.5" fill="currentColor" stroke="none" />
    <circle cx="11.8" cy="8" r="0.5" fill="currentColor" stroke="none" />
    <path d="M8.4 10.2c.9.9 2.3.9 3.2 0" />
    <path d="M9.6 4.2c-1 .1-1.7.9-1.7 1.9" />
    <path d="M4.2 17.4c0-2.7 2.6-4.3 5.8-4.3s5.8 1.6 5.8 4.3" />
  </IconBase>
);

export const IconStethoscope = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M6 2.8v4a3.4 3.4 0 0 0 6.8 0v-4" />
    <line x1="6" y1="2.8" x2="6" y2="1.6" />
    <line x1="12.8" y1="2.8" x2="12.8" y2="1.6" />
    <path d="M12.8 9.4v1.8a3.9 3.9 0 0 1-7.8 0V9.4" />
    <circle cx="15.3" cy="11.6" r="1.9" />
  </IconBase>
);

export const IconAlertTriangle = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M10 3.1 17.4 16.3H2.6z" />
    <line x1="10" y1="7.8" x2="10" y2="11.8" />
    <circle cx="10" cy="14" r="0.9" fill="currentColor" stroke="none" />
  </IconBase>
);

export const IconEmergency = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M2.2 6.2h10.5v8.7H2.2z" />
    <path d="M12.7 9.1h2.2l2.9 3.1v2.7h-2" />
    <circle cx="5.4" cy="15.1" r="1.8" />
    <circle cx="14.2" cy="15.1" r="1.8" />
    <path d="M6.3 8.1v4M4.3 10.1h4" />
  </IconBase>
);

export const IconBuilding = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <rect x="4" y="3.2" width="12" height="14.6" rx="1.2" />
    <rect x="6.1" y="5.6" width="2.2" height="2.2" rx="0.4" />
    <rect x="11.7" y="5.6" width="2.2" height="2.2" rx="0.4" />
    <rect x="6.1" y="9.6" width="2.2" height="2.2" rx="0.4" />
    <rect x="11.7" y="9.6" width="2.2" height="2.2" rx="0.4" />
    <rect x="8.3" y="13.4" width="3.4" height="4.4" rx="0.4" />
  </IconBase>
);

export const IconHospital = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <rect x="3.3" y="3" width="13.4" height="14.5" rx="1.4" />
    <path d="M10 5.4v4.4M7.8 7.6h4.4" />
    <path d="M6 12.2h2M12 12.2h2M8.4 17.5v-3.1h3.2v3.1" />
  </IconBase>
);

export const IconDialysis = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <rect x="4.1" y="2.5" width="10.2" height="14.8" rx="1.5" />
    <path d="M9.2 5.2s2.1 2.3 2.1 3.8a2.1 2.1 0 1 1-4.2 0c0-1.5 2.1-3.8 2.1-3.8Z" />
    <path d="M14.3 7.1h1.2a2 2 0 0 1 2 2v5.3a2.1 2.1 0 0 1-2.1 2.1h-1.1" />
    <path d="M6.7 14.1h5" />
  </IconBase>
);

export const IconBillCheck = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <rect x="4.6" y="2.6" width="10.8" height="14.4" rx="1.4" />
    <line x1="7" y1="6.2" x2="13" y2="6.2" />
    <line x1="7" y1="9" x2="10.6" y2="9" />
    <path d="M7.4 12.6 9.2 14.4l3.4-3.6" />
  </IconBase>
);

export const IconOtLamp = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <circle cx="10" cy="8.4" r="5.2" />
    <circle cx="10" cy="8.4" r="1.6" fill="currentColor" stroke="none" />
    <line x1="10" y1="13.6" x2="10" y2="17.4" />
    <circle cx="6.4" cy="5.9" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="13.6" cy="5.9" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="6.4" cy="10.9" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="13.6" cy="10.9" r="0.7" fill="currentColor" stroke="none" />
  </IconBase>
);

export const IconStore = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M10 2.6 17 6.2v8.2L10 17.8 3 14.4V6.2z" />
    <path d="M3 6.2 10 9.6l7-3.4" />
    <line x1="10" y1="9.6" x2="10" y2="17.8" />
  </IconBase>
);

export const IconKitchen = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M6.6 9.4a3.2 3.2 0 0 1 1-6.3 2.9 2.9 0 0 1 2.4 1.4 2.9 2.9 0 0 1 2.4-1.4 3.2 3.2 0 0 1 1 6.3" />
    <rect x="6.4" y="9.2" width="7.2" height="2.1" rx="0.6" />
    <path d="M6.8 11.3 7.1 17h5.8l.3-5.7" />
  </IconBase>
);

export const IconDietChart = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M9.8 6.3c-2.2-1.6-5 0-5 3.4 0 3.3 2.2 7.2 4.3 7.2.6 0 .9-.2.9-.2s.3.2.9.2c2.1 0 4.3-3.9 4.3-7.2 0-3.4-2.8-5-5-3.4z" />
    <path d="M10 6.3V4.2" />
    <path d="M10 4.2c.4-1 1.4-1.6 2.4-1.4" />
  </IconBase>
);

export const IconReports = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <rect x="4.4" y="2.6" width="11.2" height="14.8" rx="1.4" />
    <rect x="6.6" y="11.4" width="1.7" height="3.6" rx="0.4" fill="currentColor" stroke="none" />
    <rect x="9.3" y="9" width="1.7" height="6" rx="0.4" fill="currentColor" stroke="none" />
    <rect x="12" y="6.6" width="1.7" height="8.4" rx="0.4" fill="currentColor" stroke="none" />
  </IconBase>
);

export const IconBloodBank = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M7.6 3.4h4.8" />
    <path d="M7.8 3.4v1.9a4 4 0 0 0-2.4 3.7v4.4a3.8 3.8 0 0 0 3.8 3.8h1.6a3.8 3.8 0 0 0 3.8-3.8V9a4 4 0 0 0-2.4-3.7V3.4" />
    <line x1="8.4" y1="11.2" x2="11.6" y2="11.2" />
    <line x1="10" y1="9.6" x2="10" y2="12.8" />
  </IconBase>
);

export const IconVaccination = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <line x1="3.4" y1="16.6" x2="6.6" y2="13.4" />
    <line x1="6.6" y1="13.4" x2="12.6" y2="7.4" />
    <line x1="8" y1="14.8" x2="14" y2="8.8" />
    <line x1="12.6" y1="7.4" x2="14" y2="8.8" />
    <line x1="14" y1="8.8" x2="16.6" y2="6.2" />
    <line x1="15.3" y1="4.9" x2="17.9" y2="7.5" />
    <line x1="9.5" y1="12.5" x2="10.7" y2="11.3" />
    <line x1="11.3" y1="10.7" x2="12.5" y2="9.5" />
  </IconBase>
);

export const IconInfo = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <circle cx="10" cy="10" r="7.4" />
    <line x1="10" y1="9" x2="10" y2="14" />
    <circle cx="10" cy="6.3" r="0.9" fill="currentColor" stroke="none" />
  </IconBase>
);

export const IconInfoSolid = (props: SVGProps<SVGSVGElement>) => (
  <IconBase fill="currentColor" stroke="none" {...props}>
    <circle cx="10" cy="10" r="8.2" />
    <line x1="10" y1="9" x2="10" y2="14" stroke="#fff" strokeWidth={1.8} strokeLinecap="round" />
    <circle cx="10" cy="6.3" r="1.1" fill="#fff" />
  </IconBase>
);

export const IconRefreshCw = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M16.2 10a6.2 6.2 0 0 1-11 3.9" />
    <path d="M3.8 10a6.2 6.2 0 0 1 11-3.9" />
    <path d="M16.2 5.4v3.4h-3.4" />
    <path d="M3.8 14.6v-3.4h3.4" />
  </IconBase>
);

export const IconPrinter = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M5.4 7.6V3.4h9.2v4.2" />
    <rect x="3.2" y="7.6" width="13.6" height="6.6" rx="1.3" />
    <path d="M5.4 12.4h9.2v4.2H5.4z" />
    <circle cx="13.6" cy="10" r="0.7" fill="currentColor" stroke="none" />
  </IconBase>
);

export const IconTrash = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M3.5 5.6h13" />
    <path d="M7.6 5.6V3.8a1 1 0 0 1 1-1h2.8a1 1 0 0 1 1 1v1.8" />
    <path d="M5.7 5.6 6.4 16a1.3 1.3 0 0 0 1.3 1.2h4.6A1.3 1.3 0 0 0 13.6 16l.7-10.4" />
    <line x1="8.3" y1="8.6" x2="8.3" y2="14.2" />
    <line x1="11.7" y1="8.6" x2="11.7" y2="14.2" />
  </IconBase>
);

export const IconEdit = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M12.4 3.6a1.8 1.8 0 0 1 2.5 0l1.5 1.5a1.8 1.8 0 0 1 0 2.5L7.6 16.4l-4 .8.8-4z" />
    <line x1="11" y1="5" x2="15" y2="9" />
  </IconBase>
);

export const IconEye = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M2 10s3-5.4 8-5.4S18 10 18 10s-3 5.4-8 5.4S2 10 2 10z" />
    <circle cx="10" cy="10" r="2.6" />
  </IconBase>
);

export const IconSun = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <circle cx="10" cy="10" r="3.4" />
    <path d="M10 2.4v2M10 15.6v2M17.6 10h-2M4.4 10h-2M15.4 4.6l-1.4 1.4M6 14l-1.4 1.4M15.4 15.4 14 14M6 6 4.6 4.6" />
  </IconBase>
);

export const IconMoon = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M16.5 12.4A6.8 6.8 0 0 1 7.6 3.5a6.8 6.8 0 1 0 8.9 8.9Z" />
  </IconBase>
);

export const IconFileSpreadsheet = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M6.4 2.6h5.4l3.2 3.2v10.4a1.2 1.2 0 0 1-1.2 1.2H6.4a1.2 1.2 0 0 1-1.2-1.2V3.8a1.2 1.2 0 0 1 1.2-1.2Z" />
    <path d="M11.6 2.6v3.4h3.4" />
    <path d="M6.8 10.2h6.4M6.8 13h6.4" />
    <path d="M9.6 10.2v6.6" />
  </IconBase>
);

export const IconMedicalRecords = (props: SVGProps<SVGSVGElement>) => (
  <IconBase {...props}>
    <path d="M2.6 6.2h14.8v9.6a1.6 1.6 0 0 1-1.6 1.6H4.2a1.6 1.6 0 0 1-1.6-1.6Z" />
    <path d="M2.6 6.2V4.7a1.5 1.5 0 0 1 1.5-1.5h4l1.8 2h5.9a1.6 1.6 0 0 1 1.6 1.6" />
    <path d="M10 8.6v5.8M7.1 11.5h5.8" />
  </IconBase>
);
